<template>
  <div>
    <b-modal
      id="assignPositionID"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      size="lg"
      :visible="showAssignPositionIDs"
      @hidden="closeModal()"
    >
      <div>
        <div class="d-flex align-items-center justify-content-between p-3">
          <div class="b-modal-header">Assign Position IDs</div>
          <div class="rotate-on-hover pointer">
            <img
              :class="showSpinner && 'disabled-kanban-img'"
              @click="!showSpinner && closeModal()"
              v-b-tooltip.hover.top="'Close'"
              src="../../../assets/img/accessconnew/blueCross.svg"
              alt
            />
          </div>
        </div>
        <hr class="my-0" />
        <div class="set-padding">
          <div class="d-flex align-items-center">
            <div class="set-w-px">
              <img
                src="../../../assets/new-kanban-icons/inform-icon.svg"
                alt=""
              />
            </div>
            <div class="ml-1">
              <div class="addTocandJob-head">
                Assign position ID for Candidates
              </div>
              <div class="addTocandJob-subhead">
                Select position IDs from the dropdown to assign to candidates.
              </div>
            </div>
          </div>
          <div class="mt-3" id="customised-table">
            <b-table
              responsive
              no-border-collapse
              hover
              :items="items"
              :fields="fields"
              @sort-changed="onSortChanged"
            >
              <template #head()="{ label, field: { key, sortable } }">
                <div
                  class="d-flex align-items-center"
                  :class="key == 'name' ? 'ml-5' : ''"
                >
                  <div @click.stop="">
                    {{ label }}
                  </div>
                  <template v-if="sortable">
                    <img
                      class="ml-2"
                      v-if="sortDesc == null"
                      src="../../../assets/new-kanban-icons/empty-sort-icons.svg"
                      alt=""
                    />
                    <img
                      class="ml-2"
                      v-else-if="sortDesc"
                      src="../../../assets/new-kanban-icons/sort-descending-icons.svg"
                      alt=""
                    />
                    <img
                      v-else
                      class="ml-2"
                      src="../../../assets/new-kanban-icons/sort-ascending-icons.svg"
                      alt=""
                    />
                  </template>
                </div>
              </template>

              <template #cell()="data">
                <template v-if="data.field.key == 'name'">
                  <div class="relativeclass">
                    <div class="gridBlue-assign"></div>
                    <div
                      class="mt-1"
                      :class="data.field.key == 'name' ? 'ml-5' : ''"
                    >
                      <span
                        class="text-truncate d-inline-block"
                        style="min-width: auto; max-width: 85%"
                      >
                        {{ data.value }}</span
                      >
                    </div>
                  </div>
                </template>
                <template v-if="data.field.key == 'positionID'">
                  <div
                    ref="posdrop"
                    tabindex="0"
                    @focusout="hideDropdown"
                    class="relativeclass customised-table-dropdown"
                  >
                    <div
                      class="
                        d-flex
                        align-items-center
                        pointer
                        justify-content-center
                        h-100
                      "
                      :class="showSpinner && 'disabled-kanban-img'"
                      @click="
                        showSpinner
                          ? ''
                          : positionIDToggle == data.index
                          ? (positionIDToggle = null)
                          : (positionIDToggle = data.index)
                      "
                    >
                      <div class="w-80 d-flex justify-content-center">
                        <span
                          class="text-truncate d-inline-block"
                          style="min-width: auto; max-width: 85%"
                          >{{ data.value }}</span
                        >
                      </div>
                      <div class="w-20">
                        <img
                          v-if="positionIDToggle != data.index"
                          src="../../../assets/new-kanban-icons/down-arrow.svg"
                          alt=""
                        />
                        <img
                          v-else
                          src="../../../assets/new-kanban-icons/up-arrow.svg"
                          alt=""
                        />
                      </div>
                    </div>
                    <div
                      ref="posdrop"
                      v-if="positionIDToggle == data.index"
                      class="relativeclass"
                    >
                      <div
                        class="newInt-radio-dropdown p-0"
                        style="top: 5px; max-height: 130px; overflow-x: auto"
                      >
                        <b-form-group class="sec-mcq-datacard">
                          <b-form-radio-group
                            class="
                              newInt-radio-dropdown-inner-content
                              w-100
                              relativeclass
                            "
                            size="sm"
                            :options="positionIDOptions"
                            buttons
                            stacked
                            v-model="data.value"
                            @change="setPosition(data)"
                          >
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </b-table>
          </div>
        </div>
        <hr class="my-0" />
        <div
          class="
            d-flex
            align-items-center
            justify-content-between
            w-100
            bluebtn
            m-3
          "
        >
          <div>
            <b-button
              class="acs-cancelBtn-modal ml-2"
              :disabled="showSpinner"
              @click="!showSpinner && closeModal()"
              >Back</b-button
            >
          </div>
          <div class="d-flex align-items-center mr-4">
            <b-button
              class="acs-cancelBtn-modal mr-3"
              :disabled="showSpinner"
              @click="!showSpinner && closeModal()"
              >Cancel</b-button
            >
            <div class="position-relative">
              <b-button
                class="acs-addBtn-modal pl-4 pr-4 mr-3"
                :class="
                  showSpinner ? 'send-loader-class defaultCursor' : 'pointer'
                "
                @click="!showSpinner && addCandsToJob()"
                >{{ showSpinner ? "" : "Save" }}</b-button
              >
              <div v-if="showSpinner" class="send-loader-pos">
                <Loader />
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Loader from "../../../components/fixedcomponents/Loader.vue";

export default {
  name: "AssignPositionID",
  props: {
    showAssignPositionIDs: Boolean,
    items: Array,
    failure: Boolean,
    positionIDOptions: Array,
  },
  data() {
    return {
      showSpinner: false,
      positionIDToggle: null,
      sortDesc: null,
      fields: [
        { key: "name", label: "Candidate Name", sortable: true },
        { key: "positionID", label: "Position ID" },
      ],
    };
  },
  components: {
    Loader,
  },
  watch: {
    failure(val) {
      if (val) {
        this.showSpinner = false;
        this.$emit("change-failure");
      }
    },
  },
  methods: {
    onSortChanged(ctx) {
      this.sortDesc = ctx.sortDesc;
    },
    hideDropdown(event) {
      if (
        this.$refs.posdrop &&
        !this.$refs.posdrop.contains(event.relatedTarget)
      ) {
        this.positionIDToggle = null;
      }
    },
    setPosition(data) {
      this.$emit("set-position", data);
      this.positionIDToggle = null;
      this.$forceUpdate();
    },
    closeModal() {
      this.showSpinner = false;
      this.positionIDToggle = null;
      this.$emit("close-modal");
    },
    addCandsToJob() {
      this.showSpinner = true;
      this.$emit("add-cand-to-job", this.items);
    },
  },
};
</script>

<style>
.addTocandJob-head {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 25px;
  color: #333333;
}

.addTocandJob-subhead {
  font-family: "Montserrat", sans-serif;
  font-style: italic;
  font-weight: 500;
  font-size: 11px;
  line-height: 20px;
  color: #70737b;
}

.set-padding {
  padding: 15px 30px;
}

.set-w-px {
  width: 60px;
}

.gridBlue-assign {
  width: 4px;
  height: 46px;
  border-radius: 3px;
  position: absolute;
  left: -9px;
  top: -12px;
  background: #20639b;
}

.customised-table-dropdown {
  background: #eaeff3;
  border-radius: 25px;
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  width: 160px;
  height: 30px;
}

#assignPositionID .modal-body {
  padding: 0px;
}
</style>
